import { combineReducers } from 'redux';
import { simpleReducer } from '@mgc/map-client-shared/lib/ReduxTools';
import JoyrideActions from '../actions/joyride';

export default combineReducers({
    runJoyride: simpleReducer(false, {
        START_JOYRIDE: true,
        FINISH_JOYRIDE: false,
        CANCEL_JOYRIDE: false,
    }),

    joyrideStatus: simpleReducer(JoyrideActions.STATUS.UNFINISHED, {
        RECEIVED_USER: (a) =>
            a.payload.response.preferences.joyrideStatus ||
            JoyrideActions.STATUS.UNFINISHED,
        UPDATED_PREFERENCES: (a) =>
            a.payload.response.joyrideStatus ||
            JoyrideActions.STATUS.UNFINISHED,
        START_JOYRIDE: JoyrideActions.STATUS.UNFINISHED,
        FINISH_JOYRIDE: JoyrideActions.STATUS.FINISHED,
        CANCEL_JOYRIDE: JoyrideActions.STATUS.CANCELED,
    }),

    joyrideStatusSaveInProgress: simpleReducer(false, {
        SAVING_JOYRIDE_STATUS: true,
        SAVED_JOYRIDE_STATUS: false,
    }),
});



// WEBPACK FOOTER //
// ./app/reducers/joyride.js